import { gateway } from "../../../gateway";
import { UpdateReminderConfig } from "../interfaces/update-reminder.interface";

export const updateRemindersConfig = async (uid: string, data: Partial<UpdateReminderConfig>) => {
  const response = await gateway.patch(`reminders-settings/${uid}`, data);
  return response.data;
};
